// import React from "react";
// import Navbar from "../../Components/Navbar";
// import Footer from "../../Components/Footer/Footer";
// import "./TermsPrivacy.css";

// const TermsPrivacy = () => {
//   return (
//     <div className="terms-page">
//       <Navbar />

//       <section className="terms-hero">
//         <div className="terms-container">
//           <h1 className="terms-title">Terms & Privacy Policy</h1>
//           <p className="terms-subtitle">
//             Please read these terms carefully before using HelpNao’s platform or services. 
//             By continuing, you agree to comply with our Terms of Use and Privacy Policy.
//           </p>
//         </div>
//       </section>

//       <section className="terms-content">
//         <div className="terms-container">
//           <h2>1. Introduction</h2>
//           <p>
//             Welcome to HelpNao (“we”, “our”, “us”). HelpNao is a digital platform registered in Bangladesh 
//             that connects users with verified service providers (“Servitors”) for home and professional services. 
//             By creating an account or using our app, you agree to these Terms & Privacy Policy.
//           </p>

//           <h2>2. Account Registration</h2>
//           <p>
//             To use HelpNao, both Users and Servitors must register with accurate personal information. 
//             You are responsible for maintaining the confidentiality of your login details. 
//             Providing false or misleading information may result in suspension or permanent removal.
//           </p>

//           <h2>3. Service Use & Responsibility</h2>
//           <p>
//             Users must ensure that service requests comply with Bangladeshi law and are for lawful purposes only. 
//             Servitors must provide professional, safe, and ethical service. HelpNao acts as a digital facilitator — 
//             it does not directly employ Servitors nor guarantee outcomes but ensures verified and secure transactions.
//           </p>

//           <h2>4. Booking, Confirmation & Cancellation</h2>
//           <p>
//             Bookings are subject to Servitor availability and user confirmation. 
//             Users can reschedule or cancel before confirmation without penalty. 
//             After a Servitor accepts, cancellations may incur a small platform fee to compensate for time and travel.
//           </p>

//           <h2>5. Payments & Fees</h2>
//           <p>
//             Payments can be made through secure digital methods (Bkash, Nagad, card, etc.) or directly after service completion. 
//             HelpNao may deduct a small commission from Servitors for platform maintenance and transaction support. 
//             Any refund requests will follow HelpNao’s refund policy and will be processed within 7–10 business days.
//           </p>

//           <h2>6. Ratings & Reviews</h2>
//           <p>
//             Users may rate and review Servitors after service completion. 
//             All reviews must be honest and respectful. HelpNao reserves the right to remove abusive or fraudulent reviews.
//           </p>

//           <h2>7. Privacy & Data Protection</h2>
//           <p>
//             HelpNao collects minimal personal data (name, phone, address, service preferences) for service fulfillment only. 
//             We do not sell, rent, or share your data with third parties except where required by Bangladeshi law. 
//             Data is encrypted and stored securely. Payment information is handled through licensed payment gateways.
//           </p>

//           <h2>8. Location & Communication</h2>
//           <p>
//             Your location data is used only for finding nearby services and ensuring accurate Servitor assignment. 
//             Communication between User and Servitor is logged for safety and quality assurance. 
//             Unauthorized sharing of phone numbers or using the platform for solicitation is prohibited.
//           </p>

//           <h2>9. Safety & Security</h2>
//           <p>
//             All Servitors are verified through NID and background checks. 
//             HelpNao maintains strict safety protocols. 
//             Users should not make payments outside the app or share personal credentials. 
//             HelpNao is not responsible for any damage caused by third-party misuse or off-platform transactions.
//           </p>

//           <h2>10. Intellectual Property</h2>
//           <p>
//             All content, trademarks, and visuals on the HelpNao platform are owned or licensed by HelpNao. 
//             Unauthorized reproduction or use of content without permission is prohibited.
//           </p>

//           <h2>11. Limitation of Liability</h2>
//           <p>
//             HelpNao is not liable for indirect damages, data loss, or third-party misconduct. 
//             However, we take all reasonable steps to ensure safety, quality, and support resolution.
//           </p>

//           <h2>12. Updates to Terms</h2>
//           <p>
//             HelpNao may update these Terms or Privacy Policy periodically. 
//             Continued use of the platform after updates implies acceptance of the revised policies.
//           </p>

//           <h2>13. Contact & Legal</h2>
//           <p>
//             For questions or complaints, contact our Support Team via the HelpNao app or email 
//             <strong> support@HelpNao.com.bd</strong>.  
//             Legal correspondence may be directed to our Dhaka office in accordance with the 
//             <em>Information and Communication Technology Act, 2006 (Bangladesh)</em>.
//           </p>

//           <p className="terms-footer-note">
//             Last updated: October 2025  
//             <br />© {new Date().getFullYear()} HelpNao. All rights reserved.
//           </p>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default TermsPrivacy;




// ***** With en bn json ***** //
import React from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer/Footer";
import "./TermsPrivacy.css";
import { useTranslation } from "react-i18next";
import SEO from "../../Components/SEO/SEO";

const TermsPrivacy = () => {
  const { t } = useTranslation();

  return (
    <div className="terms-page">
      <SEO
        title="Terms & Privacy Policy | HelpNao"
        description="Read HelpNao Terms of Service and Privacy Policy for users and service providers."
        path="/legal/terms-and-privacy"
      />

      <Navbar />

      <section className="terms-hero">
        <div className="terms-container">
          <h1 className="terms-title">{t("terms.hero.title")}</h1>
          <p className="terms-subtitle">
            {t("terms.hero.subtitle")}
          </p>
        </div>
      </section>

      <section className="terms-content">
        <div className="terms-container">
          <h2>{t("terms.sections.introduction.title")}</h2>
          <p>{t("terms.sections.introduction.body")}</p>

          <h2>{t("terms.sections.registration.title")}</h2>
          <p>{t("terms.sections.registration.body")}</p>

          <h2>{t("terms.sections.service_use.title")}</h2>
          <p>{t("terms.sections.service_use.body")}</p>

          <h2>{t("terms.sections.booking.title")}</h2>
          <p>{t("terms.sections.booking.body")}</p>

          <h2>{t("terms.sections.payments.title")}</h2>
          <p>{t("terms.sections.payments.body")}</p>

          <h2>{t("terms.sections.ratings.title")}</h2>
          <p>{t("terms.sections.ratings.body")}</p>

          <h2>{t("terms.sections.privacy.title")}</h2>
          <p>{t("terms.sections.privacy.body")}</p>

          <h2>{t("terms.sections.location.title")}</h2>
          <p>{t("terms.sections.location.body")}</p>

          <h2>{t("terms.sections.safety.title")}</h2>
          <p>{t("terms.sections.safety.body")}</p>

          <h2>{t("terms.sections.ip.title")}</h2>
          <p>{t("terms.sections.ip.body")}</p>

          <h2>{t("terms.sections.liability.title")}</h2>
          <p>{t("terms.sections.liability.body")}</p>

          <h2>{t("terms.sections.updates.title")}</h2>
          <p>{t("terms.sections.updates.body")}</p>

          <h2>{t("terms.sections.contact.title")}</h2>
          <p>
            {t("terms.sections.contact.line1")}
            <strong> support@HelpNao.com.bd</strong>.
            {" "}
            {t("terms.sections.contact.line2")}
            <em> {t("terms.sections.contact.act_name")}</em>.
          </p>

          <p className="terms-footer-note">
            {t("terms.footer.last_updated")}
            <br />
            © {new Date().getFullYear()} {t("terms.footer.rights")}
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsPrivacy;
